export default class FreeFortuneChatReply {
  id: number;
  body: string;

  constructor(data?: Partial<FreeFortuneChatReply>) {
    Object.assign(this, data);
  }
}
